

// Define an enum-like object for water tracking units
const WaterTrackerUnits = Object.freeze({
    ML: 'mL',
    OZ: 'oz',
    CUP: 'cup',
});

// Conversion factors
const conversionFactors = {
    [WaterTrackerUnits.ML]: {
        [WaterTrackerUnits.OZ]: 0.033814,
        [WaterTrackerUnits.CUP]: 0.00422675,
    },
    [WaterTrackerUnits.OZ]: {
        [WaterTrackerUnits.ML]: 29.5735,
        [WaterTrackerUnits.CUP]: 0.125,
    },
    [WaterTrackerUnits.CUP]: {
        [WaterTrackerUnits.ML]: 236.588,
        [WaterTrackerUnits.OZ]: 8,
    },
};

// Function to convert a value from one unit to another, rounding to whole numbers
const convertWaterUnits = (value, fromUnit, toUnit) => {
    if (!conversionFactors[fromUnit] || !conversionFactors[fromUnit][toUnit]) {
        throw new Error(`Conversion from ${fromUnit} to ${toUnit} is not supported.`);
    }
    const convertedValue = value * conversionFactors[fromUnit][toUnit];
    return Math.round(convertedValue); // Round to the nearest whole number
};

// Exporting the units and conversion function for use in other modules
module.exports = {
    WaterTrackerUnits,
    convertWaterUnits
};
